module.exports = __webpack_public_path__ + "img/laden.48728555.jpg";